import { getField } from 'vuex-map-fields'
import { UserStatistics } from '../../models/user/UserStatistics'
import { STATE_CLEARING, USER_STATISTICS_UPDATING } from '../mutations'
import { CLEAR_MODULE_STATE, USER_STATISTICS_UPDATE } from '../actions'

const getDefaultState = () => ({
  statistics: new UserStatistics()
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    [USER_STATISTICS_UPDATING] (state, payload) {
      state.statistics = new UserStatistics(payload)
    },
    [STATE_CLEARING] (state) {
      state.statistics = getDefaultState()
    }
  },
  actions: {
    [USER_STATISTICS_UPDATE] (context, data = {}) {
      context.commit(USER_STATISTICS_UPDATING, data)
    },
    [CLEAR_MODULE_STATE] (context) {
      context.commit(STATE_CLEARING)
    }
  },
  getters: {
    getField
  }
}
